import SplitPayments from "./SplitPayments";

export {SplitPayments}